import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Subscription } from 'rxjs';
import { ProjectDetailsInitializerService } from './project-details.initializer';
import { ProjectDetailsStateService } from './services/project-details-state.service';
import { ProjectDetailsMode } from './models/project-details.types';

@Component({
  selector: 'app-project-details',
  templateUrl: './project-details.component.html',
  styleUrls: ['./project-details.component.scss']
})
export class ProjectDetailsComponent implements OnInit, OnDestroy {
  mode: ProjectDetailsMode = 'add';
  isPageInitialized = false;
  selectedIndex = 0;

  isAddOtherDetailsDisabled = true;
  isViewOtherDetailsDisabled = true;

  private subs = new Subscription();

  constructor(
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private initializer: ProjectDetailsInitializerService,
    public stateService: ProjectDetailsStateService
  ) {}

  async ngOnInit(): Promise<void> {
    const routeMode = this.activatedRoute.snapshot.data.mode as ProjectDetailsMode;
    this.mode = routeMode || 'add';
    this.stateService.setMode(this.mode);

    this.subs.add(
      this.stateService.mode$.subscribe(m => {
        this.mode = m;
        this.cdr.detectChanges();
      })
    );

    this.subs.add(
      this.stateService.selectedIndex$.subscribe(index => {
        this.selectedIndex = index;
        this.cdr.detectChanges();
      })
    );

    this.subs.add(
      this.stateService.isAddOtherDetailsDisabled$.subscribe(disabled => {
        this.isAddOtherDetailsDisabled = disabled;
        this.cdr.detectChanges();
      })
    );

    this.subs.add(
      this.stateService.isViewOtherDetailsDisabled$.subscribe(disabled => {
        this.isViewOtherDetailsDisabled = disabled;
        this.cdr.detectChanges();
      })
    );

    await this.initializer.initializeProjectDetailsData();
    this.isPageInitialized = true;
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    this.stateService.resetAllState();
  }

  tabChanged(event: MatTabChangeEvent): void {
    this.selectedIndex = event.index;
    this.stateService.setSelectedIndex(event.index);
  }

  get isOtherTabsDisabled(): boolean {
    return this.mode === 'add' ? this.isAddOtherDetailsDisabled : this.isViewOtherDetailsDisabled;
  }

  get tab0Label(): string {
    return this.mode === 'add'
      ? 'Add Project Details/Theme Allocation'
      : 'Edit Project Details/Theme Allocation';
  }
}
